import { DateFormat, formatDate } from '@helpers/utils';
import React from 'react';
import REText from '@components/wrappedBDS/REText';

interface editHistoryProps {
  history: any[];
}

const EditHistory = (props: editHistoryProps) => {
  return (
    <>
      {props.history.map((item) => (
        <div key={item.data} className="-mx-4 md:-mx-8">
          <div className="px-4 md:px-8">
            <REText className="mb-1 uppercase text-xs text-gray-600" variant="label" as="strong">
              {formatDate(item.dateTimeStamp, DateFormat.FULL)}
            </REText>

            <REText className="mb-0 text-sm text-gray-600 leading-tight" variant="helper-text">
              {item.data}
            </REText>
          </div>
        </div>
      ))}
    </>
  );
};

export default EditHistory;
